export enum KeyboardCommands {

  ENTER = 'ENTER',
  SHIFT_ENTER = 'SHIFT_ENTER'

}
